import React, { useEffect, useMemo, useState } from "react";
// REDUX
import { useSelector } from "react-redux";
// CUSTOM HOOKS
import { useLastLiftMessage } from "../socketMessageState/BankMessagesContext";
// ICONS DARK DOWN SEQUENCE
import downDark from "../../../assets/icons/escalator/es-dark-down.gif";
// ICONS DARK UP SEQUENCE
import upDark from "../../../assets/icons/escalator/es-dark-up.gif";
// ICONS LIGHT DOWN SEQUENCE
import downLight from "../../../assets/icons/escalator/es-light-down.gif";
// ICONS LIGHT UP SEQUENCE
import upLight from "../../../assets/icons/escalator/es-light-up.gif";
// ICONS STATUS
import darkStopped from "../../../assets/icons/escalator/es-dark-stopped.svg";
import iconLightStopped from "../../../assets/icons/escalator/es-light-stopped.svg";
// INTERFACES
import { RootState } from "../../../app/store";
import { LiftInterface } from "../../../interfaces/Lift.interface";
import { SocketMessageInterface } from "../../../interfaces/Monitoring.interface";
import { Usage } from "../../../flatbuffers/generated/usage/usage";
import { DeviceDirection } from "../../../types/DeviceDirection";
import { stringToUuidT } from "../../../utils/uuid";
// CONSTANTS
import { BLANK_SOCKET_MESSAGE } from "../../../constants/monitoring";

function IconDefinitionEscalatorDefault({
  iconSize = 40,
  mapViewClass = "",
  lift,
}: {
  iconSize?: number;
  mapViewClass?: string;
  lift: LiftInterface;
}) {
  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { theme } = useSelector((state: RootState) => state.home);
  const [direction, setDirection] = useState<DeviceDirection>(null);

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */
  const liftUuid = useMemo(() => stringToUuidT(String(lift.id ?? "")), [lift.id]);
  const socketMessageLift: SocketMessageInterface =
    useLastLiftMessage(liftUuid) || BLANK_SOCKET_MESSAGE;

  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************* */
  // USE EFFECT ************************************** */
  useEffect(() => {
    setDirection(socketMessageLift.direction);
  }, [socketMessageLift.direction]);

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className={`${mapViewClass || "monitoringView__controlPanelActionIcon__escalator"}`}>
      {direction === null && (
        <div>
          {(theme === "dark" || theme === "blue") && (
            <img src={darkStopped} alt="" height={iconSize} width={iconSize} />
          )}
          {theme === "light" && (
            <img src={iconLightStopped} alt="" height={iconSize} width={iconSize} />
          )}
        </div>
      )}
      {direction === Usage.Up && (
        <div>
          {(theme === "dark" || theme === "blue") && (
            <img src={upDark} alt="" height={iconSize} width={iconSize} />
          )}
          {theme === "light" && <img src={upLight} alt="" height={iconSize} width={iconSize} />}
        </div>
      )}
      {direction === Usage.Down && (
        <div>
          {(theme === "dark" || theme === "blue") && (
            <img src={downDark} alt="" height={iconSize} width={iconSize} />
          )}
          {theme === "light" && <img src={downLight} alt="" height={iconSize} width={iconSize} />}
        </div>
      )}
    </div>
  );
}

export default React.memo(IconDefinitionEscalatorDefault);
